import _URL from '../URL/index';
const axios = _URL.axios;
const limit = 15;
export default {
    services: {
        getVehicles: async (limit, page, query = "", token) => {
            return await axios(token).get(`/vehicles?limit=${limit}&page=${page}${query ? `&${query}` : ""}`);
        },
        getVehicleById: async (vehicleId, token) => {
            return await axios(token).get(`/vehicles/${vehicleId}`);
        },
        createVehicle: async (vehicle, token) => {
            return await axios(token).post(`/vehicles`, vehicle);
        },
        updateVehicleById: async (vehicleId, vehicle, token) => {
            return await axios(token).put(`/vehicles/${vehicleId}`, vehicle);
        },
        deleteVehicleById: async (vehicleId, token) => {
            return await axios(token).delete(`/vehicles/${vehicleId}`);
        },
        deleteManyVehiclesById: async (vehicles, token) => {
            return await axios(token).put(`/bulk-delete-vehicles`, { _ids: vehicles });
        },
        getVehiclesByBranchId: async (branchId, token) => {
            return await axios(token).get(`/branches/${branchId}/vehicles`);
        },
        updateAnyAttributeById: async (vehicleId, body, token) => {
            return await axios(token).patch(`/vehicles/${vehicleId}`, body);
        },

        uploadFIle: async (body, token) => {
            return await axios(token).post(`/picture/upload/insurance`, body, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        downloadCVS: async (vehicles, token) => {
            return await axios(token).post(`/export/vehicles`, vehicles);
        },
        licensePlateDuplicationCheck: async (branchId, licensePlate, token) => {
            return await axios(token).post(`/license-plate-duplication-check`, { branchId: branchId, licensePlate: licensePlate });
        },
        getCarsOptions:(token) => {
            return axios(token).get(`/cars-options`);
        }
    }
}